import React from 'react'
import { ComponentInspectorPageTemplateBridge } from './ComponentInspectorModal'
import { wrapPageElement as SharedWrapPageElement } from '../../page/wrapPageElement'

// About this component:
// Wraps every Gatsby page to extract the active Gatsby template path and register it
// with the ComponentInspector modal, so engineers can see which template file owns
// the current page alongside the React component they inspected.

// Converts a Gatsby componentChunkName back to a readable template path.
// e.g. "component---src-templates-snowflakes-landing-page-tsx" → "src/templates/snowflakes/landingPage.tsx"
function chunkNameToTemplatePath(chunkName: string): string | null {
  const prefix = 'component---src-templates-'
  if (!chunkName.startsWith(prefix)) return null
  let rest = chunkName.slice(prefix.length)
  const subdirs = ['snowflakes', 'contentful-variations', 'contentful', 'pages']
  let subdir = ''
  for (const dir of subdirs) {
    if (rest.startsWith(dir + '-')) {
      subdir = dir + '/'
      rest = rest.slice(dir.length + 1)
      break
    }
  }
  const filename = rest
    .replace(/-tsx$/, '.tsx')
    .replace(/-([a-z0-9])/g, (_, c) => c.toUpperCase())
  return 'src/templates/' + subdir + filename
}

export const wrapPageElement = (args: any, options: any) => {
  const chunkName: string =
    args.props?.pageResources?.page?.componentChunkName ?? ''
  const templateName =
    chunkNameToTemplatePath(chunkName) ||
    (args.element.type as any)?.displayName ||
    (args.element.type as any)?.name ||
    'unknown'

  const wrapped = SharedWrapPageElement(args, options)

  return (
    <div data-gatsby-template={templateName} style={{ display: 'contents' }}>
      {wrapped}
      {process.env.NODE_ENV === 'development' && (
        <ComponentInspectorPageTemplateBridge templateName={templateName} />
      )}
    </div>
  )
}
